export default class SaLogin {
  constructor() {
    this.init();
    this.events();
    this.loginCallback = null;
  }

  init() {}

  events() {
    var $this = this;

    $("#topban-member-signin")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        // $("a.nv00-gnb-v3__utility-btn.loginBtn").trigger("click");
        $(".nv00-gnb-v3__utility-user-menu-link.loginBtn").trigger("click");
      });

    $("#topban-create-an-account")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        // $("a.nv00-gnb-v3__utility-btn.loginBtn").trigger("click");
        $(".nv00-gnb-v3__utility-user-menu-link.loginBtn").trigger("click");
      });

    $("#member-signin")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $this.redirectToAccountSamsungLogin();
      });

    $("#create-an-account")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        $this.redirectToAccountSamsungLogin();
      });
  }

  //Method to set the login success callback
  onLoginSuccess(callback) {
    this.loginCallback = callback;
  }


  redirectToAccountSamsungLogin() {
    var $this = this;

    window.state.isRedirectedToSALogin = true;
    //window.isUserLoggedIn = true;

    if ($this.saveState()) {
      // $("a.nv00-gnb-v3__utility-btn.loginBtn").trigger("click");
      $(".nv00-gnb-v3__utility-user-menu-link.loginBtn").trigger("click");
      // $('#sa-login').show();

      // $(document).trigger("loginConfirmed");

      if (typeof this.loginCallback === 'function') {
        this.loginCallback();
      }
    }
  }

   isUserLoggedIn() {
    //var host =   (window.location.host == "www.samsung.com")? "https://www.samsung.com":"https://p6-qa.samsung.com";

    var host = "";

    switch (window.location.host) {
      case "www.samsung.com":
        host = "https://www.samsung.com";
        break;
      case "p6-qa.samsung.com":
        host = "https://p6-qa.samsung.com";
        break;
      case "hshopfront.samsung.com":
        host = "https://hshopfront.samsung.com";
        break;
      case "p6spp-eu-author.samsung.com":
        host = "https://p6spp-eu-author.samsung.com";
        break;
    }

    //var host = "https://www.samsung.com";

    if (host != "" || site == "ie") {
      var path = "/aemapi/v6/data-login/callSALogin.uk.json";

      var url = host + path;

      return $.get(url, function (response) {
        var guId = $.trim(window.cookies.getCookie("guid"));
        var flpe = window.cookies.getCookie("flpe");

        if (response.redCookieChk === "Y" && guId !== "" && flpe !== "") {
          window.state.isUserLoggedIn = true;
        }
      });
    } else {
      window.state.isUserLoggedIn = true
    } // for dev only
  }


  getAccountDetails() {
    function setUserInfo(a, guid) {
      var b = CryptoJS.enc.Utf8.parse("cedc6238tqcf1t4f0vl7g50mc70d6a5a");
      b = (
        CryptoJS.AES.encrypt(u.cookie.guid, b, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7,
        }) + "cedc6238tqcf1t4f0vl7g50mc70d6a5a"
      ).substring(0, 32);
      var c = CryptoJS.enc.Utf8.parse(b);
      b = CryptoJS.AES.decrypt(u.cookie.flpe, c, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });
      b = CryptoJS.enc.Utf8.stringify(b);
      b = JSON.parse(decodeURIComponent(b));

      var f = !1;
      a = CryptoJS.AES.decrypt(a, c, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });
      a = CryptoJS.enc.Utf8.stringify(a);
      JSON.parse(decodeURIComponent(a)).emailAddr === b.emailAddr && (f = !0);

      if (f && site == "uk") {
        //console.log(b.firstName + " " + b.lastName + " " + b.emailAddr);
        var userInfo = {};
        userInfo.firstName = b.firstName;
        userInfo.lastName = b.lastName;
        userInfo.email = b.emailAddr;
        userInfo.guid = guid;
        window.state.userInfo = userInfo;

        $("#top-banner .login #tb-first-name").html(userInfo.firstName);
        $("#top-banner .logout").hide();
        $("#top-banner .login").show();
      }
    }

    function getUserInfo() {
      var url = "/aemapi/v6/mysamsung/uk/scv/newproducts"
        // window.location.host == "hshopfront.samsung.com"
        //   ? "/aemapi/v6/mysamsung/scv/newproducts"
        //   : "/aemapi/v6/mysamsung/scv/products";
        // /aemapi/v6/mysamsung/scv/newproducts

      $.ajax({
        crossDomain: !0,
        dataType: "json",
        type: "GET",
        data: {
          siteCode: u.siteMeta.siteCode,
          top: "100",
          ncp: Math.random(),
        },
        url: url,
        success: function (a) {
          if (
            null != a &&
            a &&
            200 == a.statusCode &&
            a.resultData &&
            a.resultData.myProducts
          ) {
            var b = a.resultData.myProducts;
            a = b.basicInfo;
            setUserInfo(a.flpeValidation, a.guid);
            u.siteMeta.isShopSite && t("myProducts", a.productCnt);
            b = b.products.productList.items;
            for (var c = 0; c < b.length; c++) {
              var f = b[c];


              window.digitalData.user.userDeviceList.push({
                userID: a.guid,
                deviceID: f.id,
                deviceTypeCode: f.modelCategory,
                deviceModelID: f.modelCode,
                // deviceUniqueID: f.modelCode,              xxx
                deviceSerialNumberText: f.serialNumber,
                //deviceRegistrationDate: f.createdDateTime, xxx
                deviceName: f.productName,
                encImei: f.imei,
              });
            }
          }
        },
      });
    }

    function t(a, b) {
      u.$ui.shopInfo.countLabels[a] && u.$ui.shopInfo.countLabels[a].text(b);
    }

    function w(a) {
      u.siteMeta.multiLanguageEnabled &&
        a.setRequestHeader("x-ecom-locale", u.siteMeta.hreflang);
    }

    function v(a, b) {
      return b ? u.siteMeta.storeWebDomain + a : u.siteMeta.storeDomain + a;
    }

    function x(a, b) {
      b = c.trim(b);
      "" !== b && a.push(b);
    }

    var u = {
      siteCode: "uk",
      hreflang: "en-GB",
      countryIsoCode: "GBR",
    };

    u.siteMeta = $.extend(
      {
        siteCode: $("#siteCode").val(),
        multiLanguageEnabled: "Y" === $("#multiLanguageYn").val(),
        countryIsoCode: $("#countryIsoCode").val(),
        storeDomain: $("#storeDomain").val(),
        storeWebDomain: $("#storeWebDomain").val(),
      },
      u
    );

    u.cookie = {
      guid: $.trim(window.cookies.getCookie("guid")),
      jwtToken: $.trim(
        window.cookies.getCookie("jwt_" + u.siteMeta.countryIsoCode)
      ),
      flpe: window.cookies.getCookie("flpe"),
    };

    u.cookie.encGuid = encodeURIComponent(u.cookie.guid);

    getUserInfo();
  }

  saveState() {
    var userState = JSON.stringify(window.state);
    window.localStorage.setItem("user-state", userState);
    return true;
  }

  retriveState() {
    var stateString = window.localStorage.getItem("user-state");

    if (stateString != "") {
      try {
        var stateObject = JSON.parse(stateString);

        if (
          $.type(stateObject) === "object" &&
          stateObject._isRedirectedToSALogin
        ) {
          window.state.initState(stateObject);
          window.localStorage.removeItem("user-state");
        }

        return true;

        // Need to be changed only when state has loginCTA clicked then we have to reset the state
      } catch (e) {
        // Return a default object, or null based on use case.
        console.log("Exception at the time of retriving persistant Object");
        return false;
      }
    } else {
      return false;
    }
  }

  scrollTo(elem) {
    var scrollTop = $(elem).position().top - 20;

    setTimeout(function () {
      $("html, body").animate(
        {
          scrollTop: scrollTop,
        },
        500,
        function () {}
      );
    }, 500);
  }
}
